import moment from 'moment'
import namecase from 'namecase'
import { cloneDeep, camelCase, trim } from 'lodash'

export const formatAuctionDateRange = (startDate, endDate) => {
  startDate = moment(startDate, 'YYYY-MM-DD')
  endDate = moment(endDate, 'YYYY-MM-DD')
  if (startDate.isValid() && endDate.isValid()) {
    // year difference
    if (startDate.year() - endDate.year() < 0) {
      return (
        startDate.format('MMM D, YYYY') + ' - ' + endDate.format('MMM D, YYYY')
      )
    } else if (startDate.month() - endDate.month() < 0) {
      // month difference
      return startDate.format('MMM D') + ' - ' + endDate.format('MMM D')
    } else {
      // same month
      return startDate.format('MMM D') + ' - ' + endDate.format('D')
    }
  }
  // default should be determined on start date
  return startDate.isValid() ? startDate.format('MMM D') : 'TBD'
}

export const formatAuctionDateTime = (date, time) => {
  date = moment(date, 'YYYY-MM-DD')
  date = date.isValid() ? date.format('MMM DD') : 'Date TBD'
  time = moment(time, 'hh:mm a')
  time = time.isValid() ? time.format('h:mma') : 'Time - Coming Soon'
  time = time === '12:00am' ? 'Time - Coming Soon' : time
  return date + ', ' + time
}

export const formatAuctionDate = date => {
  date = moment(date, 'YYYY-MM-DD')
  date = date.isValid() ? date.format('MMM DD') : 'Date TBD'
  return date
}

export const formatAuctionTime = time => {
  time = moment(time, 'hh:mm A')
  time = time.isValid() ? time.format('h:mm A') : 'Time - Coming Soon'
  time = time === '12:00 AM' ? 'Time - Coming Soon' : time
  return time
}

export const formatTitlelize = val => namecase(trim(val))

// @deprecated
//
// Please do not use this. It's confusing and introduces needless cruft into code which doesn't require it.
// Consider that in almost every place you use this there will be a required corresonding reverse function, likely
// called `uiToApi`, or something like that. A better pattern is to keep the data in the format the API returns were
// possible and compute UI-specific data structures and augmented client-only fields as needed, either in a WeakMap with
// the data being the reference key, or by leveraging the `__computed__` key pattern we use extensively.
export const apiToUiHelper = apiData => {
  const apiValues = cloneDeep(apiData)
  const keys = Object.keys(apiValues)
  const uiValues = keys.reduce((uiValues, apiKey) => {
    const uiKey = camelCase(apiKey)
    return {
      ...uiValues,
      [uiKey]: apiValues[apiKey],
    }
  }, {})
  return uiValues
}

export const formatOfferDate = (date, defaultValue = 'TBD') =>
  date
    ? moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('M/D/YY')
    : defaultValue
